import { LocalStorageProvider } from '@dicetechnology/dice-unity/lib/services/Storage/localStorage';
import autoBind from 'auto-bind';

const prefix = 'dice-chromecast';

export class LocalStorageManager extends LocalStorageProvider {
    private _environment: string;
    private _realm: string;

    constructor(realm: string, environment: string) {
        super(`${prefix}_${realm}_${environment}`);
        autoBind(this);

        this._realm = realm;
        this._environment = environment;
    }

    public set = async (key: string, value: string, withRetry = true): Promise<void> => {
        try {
            localStorage.setItem(this.getKey(key), value);
        } catch (error) {
            if (error instanceof Error && error.name === 'QuotaExceededError' && withRetry) {
                console.error('QuotaExceededError thrown. Will attempt to clear space and retry', { key, value });
                this.cleanUp();
                this.set(key, value, false);
            } else {
                throw error;
            }
        }
    };

    /**
     * clears values from localStorage that don't have the same realm/environment
     */
    private cleanUp = (): void => {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const storageKey = localStorage.key(i);
            if (!storageKey?.startsWith(prefix)) {
                continue;
            }

            // Returns something like: ['dice-chromecast', 'dce.ufc', 'prod', 'authToken']
            // or: ['dice-chromecast', 'dce.skynz', 'prod', '', 'LABEL', 'SERVICE']
            const [, realm, env] = storageKey.split('_');
            if (realm !== this._realm || env !== this._environment) {
                try {
                    localStorage.removeItem(storageKey);
                } catch (error) {
                    console.error('Failed to removeItem', error);
                }
            }
        }
    };
}
